function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-outside-1_2449_781",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 94,
  height: 38,
  fill: "black"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  width: 94,
  height: 38
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.37258 5.37258 0 12 0H81C87.6274 0 93 5.37258 93 12V24C93 30.6274 87.6274 36 81 36H12C5.37258 36 0 30.6274 0 24V12Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.37258 5.37258 0 12 0H81C87.6274 0 93 5.37258 93 12V24C93 30.6274 87.6274 36 81 36H12C5.37258 36 0 30.6274 0 24V12Z",
  fill: "#EC7963"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H93H0ZM94 25C94 32.1797 88.1797 38 81 38H14C6.26801 38 0 31.732 0 24C0 29.5228 5.37258 34 12 34H81C87.0751 34 92 29.5228 92 24L94 25ZM0 36V0V36ZM81 0C88.1797 0 94 5.8203 94 13V25C94 32.1797 88.1797 38 81 38V34C87.0751 34 92 29.5228 92 24V12C92 5.37258 87.0751 0 81 0Z",
  fill: "#D26855",
  mask: "url(#path-1-outside-1_2449_781)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.901 22.3936C24.901 22.8431 24.5562 23.1833 24.0944 23.1833C23.7804 23.1833 23.528 23.0618 23.2201 22.7763L20.8066 20.5286C20.7758 20.4983 20.7328 20.4861 20.6773 20.4861H19.0396C18.153 20.4861 17.6666 19.9941 17.6666 19.0707V16.9385C17.6666 16.0151 18.153 15.5291 19.0396 15.5291H20.6835C20.7328 15.5291 20.7758 15.5109 20.8128 15.4806L23.2201 13.2511C23.5526 12.9413 23.7804 12.8198 24.0882 12.8198C24.5562 12.8198 24.901 13.1843 24.901 13.6338V22.3936Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.239 21.9866C30.0419 22.2721 29.691 22.3389 29.4016 22.1627C29.0938 21.9805 29.0568 21.6039 29.2723 21.2698C29.8757 20.3646 30.2328 19.2044 30.2328 17.9955C30.2328 16.7866 29.8819 15.6203 29.2723 14.7212C29.0507 14.3871 29.0938 14.0105 29.4016 13.8282C29.691 13.6521 30.0419 13.7189 30.239 14.0044C31.0086 15.0796 31.4457 16.5193 31.4457 17.9955C31.4457 19.4716 31.0024 20.8992 30.239 21.9866Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7885 20.4497C27.5977 20.717 27.2467 20.7777 26.9697 20.6076C26.6618 20.4071 26.6064 20.0487 26.8465 19.6721C27.1605 19.2165 27.3391 18.6212 27.3391 17.9955C27.3391 17.3698 27.1667 16.7684 26.8465 16.3189C26.6003 15.9483 26.6618 15.5838 26.9697 15.3894C27.2467 15.2072 27.5977 15.274 27.7885 15.5352C28.2688 16.1852 28.552 17.0661 28.552 17.9955C28.552 18.9249 28.2688 19.8118 27.7885 20.4497Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M56.676 14.376V13.144H53.956V14.376H56.676ZM58.084 12.184V15.32H52.612V12.184H58.084ZM50.068 14.376V13.144H47.396V14.376H50.068ZM51.492 12.184V15.32H46.068V12.184H51.492ZM48.004 20.6H51.204V19.448H48.004V20.6ZM48.004 17.224V18.344H51.204V17.224H48.004ZM56.132 18.344V17.224H52.724V18.344H56.132ZM56.132 20.6V19.448H52.724V20.6H56.132ZM59.092 22.824V24.12H52.724V26.248H51.204V24.12H44.996V22.824H51.204V21.784H46.548V16.04H57.652V21.784H52.724V22.824H59.092ZM63.716 14.568V16.584H62.26V13.16H68.372C68.164 12.744 67.908 12.28 67.652 11.912L69.108 11.448C69.508 11.976 69.908 12.632 70.132 13.16H75.684V16.584H74.164V14.568H63.716ZM75.828 20.104V21.528H69.764V24.52C69.764 25.352 69.556 25.768 68.9 25.992C68.26 26.232 67.332 26.248 66.02 26.248C65.924 25.816 65.62 25.144 65.38 24.76C66.388 24.792 67.492 24.792 67.796 24.776C68.084 24.776 68.18 24.696 68.18 24.472V21.528H62.116V20.104H68.18V19.176C68.996 18.776 69.876 18.152 70.596 17.544H64.772V16.168H72.1L72.436 16.088L73.444 16.856C72.468 17.848 71.124 18.888 69.764 19.672V20.104H75.828Z",
  fill: "white"
});

function SvgWords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 38,
    viewBox: "0 0 94 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWords);
export default __webpack_public_path__ + "static/media/words.7fb7e733.svg";
export { ForwardRef as ReactComponent };